import { toast } from 'react-toastify';

const copyToClipboard = async (...args) => {
  let label, value;
  if (args.length === 1) {
    label = args[0];
    value = label;
  }
  if (args.length === 2) {
    label = args[0];
    value = args[1];
  }
  await navigator.clipboard.writeText(value);

  toast.success(`${label} copied!`);
};

export { copyToClipboard };
